import { alpha, styled } from '@mui/material/styles';

export const DivRootStyled = styled('div', {
  name: 'DivRootStyled',
})(({ theme }) => ({
  outline: `1px solid ${alpha(theme.palette.secondary.main, 0.6)}`,
  borderRadius: '5px',
}));
